import React from 'react';

export default function ArchivePage() {
  return null;
}
